import styles from './VarItem.module.css';

const LIMIT_LENGHT = 35;

const calculateLines = (string, limit = LIMIT_LENGHT) =>
  string
    ?.split(/\s+/)
    .reduce(
      (acc, word) =>
        acc[acc.length - 1].length + word.length < limit
          ? [
              ...acc.slice(0, acc.length - 1),
              acc[acc.length - 1] + `${acc[acc.length - 1] ? ' ' : ''}${word}`,
            ]
          : [...acc, word],
      ['']
    );

const VarItem = ({
  item,
  i,
  answerFontSize,
  varNumFontSize,
  isQuestionImg,
  currentState,
}) => {
  let lines = calculateLines(item.comment);
  let isLong = false;
  let currLimit = LIMIT_LENGHT;
  let recalculationIterations = 0;

  while (lines.length >= 2) {
    isLong = true;
    currLimit += 5;
    lines = calculateLines(item.comment, currLimit);
    recalculationIterations++;
  }
  return (
    <div
      style={{ opacity: currentState === 'S2' ? 0.5 : 1 }}
      className={styles.varInfo}
      // style={{ minHeight: isQuestionImg ? 'none' : '20rem' }}
    >
      <div
        style={{
          fontSize: `${varNumFontSize}rem`,
          lineHeight: `${varNumFontSize}rem`,
        }}
        className={styles.varNum}>
        {i + 1}
      </div>
      <div
        className={styles.varTitle}
        style={{
          fontSize: `${
            isLong ? answerFontSize * 1 - 0.2 * lines.length : answerFontSize
          }rem`,
          padding: isLong
            ? `1.5rem ${isQuestionImg ? '2rem' : '3rem'}`
            : isQuestionImg
            ? '2rem'
            : '3rem',
        }}>
        {item.comment}
      </div>
    </div>
  );
};

export default VarItem;
